<div *ngIf="!isBorne && !isPartnerConditionsHeader" >
  <app-header *ngIf="!isPartnerHeader"></app-header>
  <app-header-partner *ngIf="isPartnerHeader" [partnerName]="partnerName"></app-header-partner>
</div>
<router-outlet></router-outlet>
<app-footer *ngIf="!isBorne && !isPartnerConditionsHeader"></app-footer>
